import { Component } from '@angular/core';
import { TextoTermosService } from './texto-termos-contratacao-tag.service';

@Component({
    selector: 'app-texto-termos-contratacao-tag',
    templateUrl: './texto-termos-contratacao-tag.component.html',
    standalone: false
})
export class TextoTermosContratacaoComponentTag  {

  constructor(private termosService: TextoTermosService) {}

  termosContratacao$ = this.termosService.termosContratacao$;

}